import { useQuery } from '@tanstack/react-query';
import { useServices } from 'index';
import { adminTrackmanParametersV2QueryKey } from './useTrackmanParametersV2';

export const useTrackmanParameterV2 = (id?: string) => {
  const service = useServices().trackmanParametersV2Service;
  return useQuery({
    queryKey: [...adminTrackmanParametersV2QueryKey, id],
    queryFn: () => service.getParameter(id!),
    enabled: !!id,
    refetchOnWindowFocus: false,
  });
};
